module.exports = __webpack_public_path__ + "static/img/nav_quit.f646c63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_quit.svg
// module id = hMll
// module chunks = 1